import React, { useState } from 'react'

import { DatePicker } from '@material-ui/pickers'
import { CircularProgress, Input, TableCell } from '@material-ui/core'
import { makeStyles, ThemeProvider } from '@material-ui/core/styles'

import { useBoolState } from '../../../hooks/commonHooks'

import { emDash } from '../../../common/stringUtility'
import { datePickerTheme } from '../../../common/appTheme'
import { dateFormats, tryFormatDateOnly } from '../../../common/dateTimeUtility'

export type DatePickerCellProps = {
  value: Date | null

  minDate?: Date

  maxDate?: Date

  onChange: (date: Date | null) => Promise<void>
}

export const DatePickerCell =
  ({value, minDate, maxDate, onChange}: DatePickerCellProps) => {
    const classes = useStyles()

    const [selectedDate, setSelectedDate] = useState<Date | null>(value)

    const [isOpen, setOpen, setClosed] = useBoolState()
    const [isLoading, setIsLoading] = useState(false)

    const onDateChange =
      async (newDate: Date | null) => {
        setSelectedDate(newDate)
        setIsLoading(true)

        try {
          await onChange(newDate)
        } finally {
          setIsLoading(false)
        }
      }

    // NOTE: Picker's nested dialog can't coexist with cell click events. Its default container is body.
    return (
      <TableCell className="table-border">
        {
          isLoading
          ? <CircularProgress size={31}/>
          : isOpen
            ? // DatePicker is slow - render only when it's actually needed
            <ThemeProvider theme={datePickerTheme}>
              <DatePicker
                open
                clearable
                format={dateFormats.dateOnly}
                value={selectedDate}
                onChange={onDateChange}
                onClose={setClosed}
                minDate={minDate}
                maxDate={maxDate}
                clearLabel="Очистить"
                okLabel="Принять"
                cancelLabel="Отменить"
                invalidLabel="Невалидная дата"
                emptyLabel={emDash}
                InputProps={{className: classes.fixFontSize}}
              />
            </ThemeProvider>
            :
            <Input
              readOnly
              className={classes.fixFontSize}
              value={tryFormatDateOnly(selectedDate) ?? emDash}
              onClick={setOpen}
            />
        }
      </TableCell>
    )
  }

const useStyles = makeStyles(
  () => ({
    fixFontSize: {
      fontSize: 'inherit'
    }
  }))